import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AgentLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/agent/login');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex">
        <aside className="w-64 bg-blue-900 text-white min-h-screen">
          <div className="p-4">
            <h2 className="text-2xl font-bold">Agent Panel</h2>
            <p className="text-sm text-blue-200 mt-1">{user?.name}</p>
          </div>
          <nav className="mt-8">
            <Link to="/agent/dashboard" className="block px-4 py-3 hover:bg-blue-800">
              Dashboard
            </Link>
            <Link to="/agent/scan" className="block px-4 py-3 hover:bg-blue-800">
              Scan Ticket
            </Link>
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-3 hover:bg-blue-800 text-red-300"
            >
              Logout
            </button>
          </nav>
        </aside>

        <main className="flex-1 p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AgentLayout;

